export const APP_THEMING_DEFAULT = 'ppg-light';
